"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FormItem = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _initializerDefineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/initializerDefineProperty"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _applyDecoratedDescriptor2 = _interopRequireDefault(require("@babel/runtime/helpers/applyDecoratedDescriptor"));

var _initializerWarningHelper2 = _interopRequireDefault(require("@babel/runtime/helpers/initializerWarningHelper"));

var _vuePropertyDecorator = require("vue-property-decorator");

var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _dec8, _dec9, _class, _class2, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _temp;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { return function () { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (_isNativeReflectConstruct()) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var FormItem = (_dec = (0, _vuePropertyDecorator.Inject)(), _dec2 = (0, _vuePropertyDecorator.Prop)(), _dec3 = (0, _vuePropertyDecorator.Prop)(), _dec4 = (0, _vuePropertyDecorator.Prop)({
  default: false
}), _dec5 = (0, _vuePropertyDecorator.Prop)({
  default: function _default() {
    return [];
  }
}), _dec6 = (0, _vuePropertyDecorator.Prop)(), _dec7 = (0, _vuePropertyDecorator.Prop)(), _dec8 = (0, _vuePropertyDecorator.Prop)({
  default: true
}), _dec9 = (0, _vuePropertyDecorator.Watch)('name', {
  immediate: true,
  deep: false
}), (0, _vuePropertyDecorator.Component)(_class = (_class2 = (_temp = /*#__PURE__*/function (_Vue) {
  (0, _inherits2.default)(FormItem, _Vue);

  var _super = _createSuper(FormItem);

  function FormItem() {
    var _this;

    (0, _classCallCheck2.default)(this, FormItem);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _initializerDefineProperty2.default)(_this, "form", _descriptor, (0, _assertThisInitialized2.default)(_this));
    (0, _initializerDefineProperty2.default)(_this, "name", _descriptor2, (0, _assertThisInitialized2.default)(_this));
    (0, _initializerDefineProperty2.default)(_this, "label", _descriptor3, (0, _assertThisInitialized2.default)(_this));
    (0, _initializerDefineProperty2.default)(_this, "required", _descriptor4, (0, _assertThisInitialized2.default)(_this));
    (0, _initializerDefineProperty2.default)(_this, "rules", _descriptor5, (0, _assertThisInitialized2.default)(_this));
    (0, _initializerDefineProperty2.default)(_this, "options", _descriptor6, (0, _assertThisInitialized2.default)(_this));
    (0, _initializerDefineProperty2.default)(_this, "extra", _descriptor7, (0, _assertThisInitialized2.default)(_this));
    (0, _initializerDefineProperty2.default)(_this, "formLayout", _descriptor8, (0, _assertThisInitialized2.default)(_this));
    return _this;
  }

  (0, _createClass2.default)(FormItem, [{
    key: "nameChange",
    value: function nameChange(name, oldName) {
      var form = this.form;

      if (!form) {
        console.error('[FormItem]: can not use FormItem without Form tag');
        return;
      }

      if (oldName) {
        form.removeField(oldName);
      }

      if (name) {
        form.addField(name, this);
      }
    }
  }, {
    key: "destroyed",
    value: function destroyed() {
      var name = this.name,
          options = this.options,
          form = this.form;

      if (options && options.preserve) {
        return;
      }

      if (form && name) {
        form.removeField(name);
      }
    }
  }, {
    key: "render",
    value: function render(h) {
      var _class4;

      var name = this.name,
          factRules = this.factRules,
          options = this.options,
          label = this.label,
          extra = this.extra,
          required = this.required,
          form = this.form,
          formLayout = this.formLayout;
      var input = this.$slots.default;
      var errorMsg; // 获取输入组件

      if (Array.isArray(input)) {
        input = input[0];
      }

      if (input && name) {
        input = form.bindField(name, _objectSpread(_objectSpread({}, options), {}, {
          rules: factRules
        }))(input);
        var errors = form.getError(name);

        if (errors && errors.length) {
          errorMsg = errors[0];
        }
      }

      var item = h("div", {
        "class": "mh-form-item-control-wrapper"
      }, [h("span", {
        "class": "mh-form-item-control"
      }, [input]), errorMsg && h("div", {
        "class": "mh-form-item-error"
      }, [errorMsg.replace(/%l/, label || '')]), extra && h("div", {
        "class": "mh-form-item-extra"
      }, [extra])]);

      if (!formLayout) {
        return item;
      }

      return h("div", {
        "class": (_class4 = {
          'mh-form-item': true,
          'mh-form-item-help': errorMsg || extra
        }, (0, _defineProperty2.default)(_class4, "mh-form-item-name-".concat(name), name), (0, _defineProperty2.default)(_class4, 'has-error', errorMsg), _class4)
      }, [h("div", {
        "class": {
          'mh-form-item-label': true,
          'mh-form-item-label-required': required
        }
      }, [label && h("label", [label])]), item]);
    }
  }, {
    key: "factRules",
    get: function get() {
      var rules = this.rules,
          required = this.required; // 把 required 添加到 rules 中

      var rl = (0, _toConsumableArray2.default)(rules);

      if (required) {
        var f = rl.find(function (r) {
          return r.type === 'required';
        });

        if (!f) {
          rl.push({
            type: 'required'
          });
        }
      }

      return rl;
    }
  }]);
  return FormItem;
}(_vuePropertyDecorator.Vue), _temp), (_descriptor = (0, _applyDecoratedDescriptor2.default)(_class2.prototype, "form", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = (0, _applyDecoratedDescriptor2.default)(_class2.prototype, "name", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = (0, _applyDecoratedDescriptor2.default)(_class2.prototype, "label", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = (0, _applyDecoratedDescriptor2.default)(_class2.prototype, "required", [_dec4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = (0, _applyDecoratedDescriptor2.default)(_class2.prototype, "rules", [_dec5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = (0, _applyDecoratedDescriptor2.default)(_class2.prototype, "options", [_dec6], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = (0, _applyDecoratedDescriptor2.default)(_class2.prototype, "extra", [_dec7], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor8 = (0, _applyDecoratedDescriptor2.default)(_class2.prototype, "formLayout", [_dec8], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), (0, _applyDecoratedDescriptor2.default)(_class2.prototype, "nameChange", [_dec9], Object.getOwnPropertyDescriptor(_class2.prototype, "nameChange"), _class2.prototype)), _class2)) || _class);
exports.FormItem = FormItem;